<style scoped>
.this__icon {
  position: relative;
  top: 2px;
}
</style>
<template>
  <div>
    <div v-if="step == 0" class="demo__color--black">
      <div
        class="demo__margin-top--16 demo__margin-bottom--24 demo__font--16 demo__weight--400"
      >
        {{ $t("Subs.unsub.title") }}
      </div>

      <div
        v-for="feature in plan?.features"
        :key="feature.id"
        class="demo__flex demo__flex-top demo__text-left demo__margin-top--16"
      >
        <i
          class="fa-light fa-times demo__color--brandPrimary demo__font--16 demo__margin-right--8 this__icon"
        ></i>
        <span class="demo__font--16 demo__weight--400">
          {{ feature.name }}
        </span>
      </div>
    </div>
    <div v-if="step == 1" class="demo__margin-top--24">
      <div
        v-for="reason in reasons"
        :key="reason.id"
        class="demo__flex demo__flex-middle demo__text-left demo__margin-top--16"
      >
        <a-checkbox
          class="demo__Checkbox demo__Checkbox--small demo__Checkbox--white"
        ></a-checkbox>
        <span
          class="demo__font--14 demo__weight--400 demo__margin-left--8 demo__color--black"
        >
          {{ $t("Subs.unsub.reasons." + reason.id) }}
        </span>
      </div>
    </div>
    <div class="demo__margin-top--24" v-if="step < 2">
      <a-button class="demo__button demo__button--gray" @click="nextStep()">
        {{ $t("Subs.unsub.yes") }}
      </a-button>
      <a-button
        class="demo__button demo__button--base demo__margin-left--16"
        @click="$root.unsubCancel()"
      >
        {{ $t("Subs.unsub.no") }}
      </a-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      step: 0,
      reasons: [
        { id: 0, check: false },
        { id: 1, check: false },
        { id: 2, check: false },
        { id: 3, check: false },
      ],
    };
  },
  computed: {
    ...mapGetters(["subsPlans", "user", "api"]),
    plan() {
      return (
        this.$_.findWhere(this.subsPlans, {
          id: this.user?.plan?.subscription_plan,
        }) || this.subsPlans[this.subsPlans.length - 1]
      );
    },
  },
  created() {
    this.$accessModule("unsub", this);
  },
  methods: {
    nextStep() {
      if (this.step === 0) {
        this.step = 1;
        this.$root.$emit("updateSubsModalInfo", {
          currentField: "title",
          currentValue: this.$t("Subs.unsub.modalTitle2"),
        });
      } else {
        this.$root.unsubscribeHandler();
      }
    },
  },
};
</script>
